import { render, staticRenderFns } from "./editGoodsCategory.vue?vue&type=template&id=6ee96e88&"
import script from "./editGoodsCategory.vue?vue&type=script&lang=js&"
export * from "./editGoodsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports